export const SORTING = 'SORTING';

export const setSessionSortingAction = (filter: Object) => ({
  type: SORTING,
  payload: filter
});
